import graphql from "babel-plugin-relay/macro";
import { AddressType } from "components/address/AddressForm";
import { ReadonlyAddress } from "components/address/ReadonlyAddress";
import { accountMessages } from "domain/account/accountMessages";
import { Addresses_account } from "generatedQueries/Addresses_account.graphql";
import React, { FC } from "react";
import { createFragmentContainer } from "react-relay";
import { Col, Row } from "reactstrap";
import { Message } from "shared/components/Message";

export interface IAddresses {
    account: Addresses_account;
}

const InternalAddresses: FC<IAddresses> = ({
    account,
}) => (
    <section aria-labelledby="addressSectionHeading">
        <h4 className="sr-only" id="addressSectionHeading"><Message message={accountMessages.addressSectionLabel} /></h4>
        <Row>
            <Col sm={6}>
                <ReadonlyAddress address={account.physicalAddress} addressType={AddressType.Physical} />
            </Col>
            <Col sm={6}>
                <ReadonlyAddress address={account.mailingAddress} addressType={AddressType.Mailing} />
            </Col>
        </Row>
    </section>
);

export const Addresses = createFragmentContainer(InternalAddresses, {
    account: graphql`
        fragment Addresses_account on Account {
            physicalAddress {
                ...ReadonlyAddress_address
            }
            mailingAddress {
                ...ReadonlyAddress_address
            }
        }`,
});
